import creditScoreBad from 'img/vanskilaskra-ekki-ok.svg';
import creditScoreOk from 'img/vanskilaskra-ok.svg';
import type { Translate } from 'providers/ApplicationContext';
import type { Products } from 'types';

export function CreditCheckButtonText(products: Products, translate: Translate) {
	if (!products.externalCreditCheck) {
		return translate('credit_info_lookup', 'products');
	}

	if (products.isElidgableForDerivatives) {
		return (
			<>
				{translate('credit_score_good', 'products')}
				<img alt="" className="ms-2" src={creditScoreOk} />
			</>
		);
	}

	return (
		<>
			{translate('credit_score_bad', 'products')}
			<img alt="" className="ms-2" src={creditScoreBad} />
		</>
	);
}
